import { useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "utils/Table/Table";
import BankingWalletFilters from "../common/BankingWalletFilters";
import {
	bankingCardsTableData,
	bankingCardsTableHeadings,
	bankingWalletsFiltersDefaultValues,
} from "../helpers/data";

const BankingCards = () => {
	const history = useHistory();
	const [formValues, setFormValues] = useState({
		...bankingWalletsFiltersDefaultValues,
	});

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const handleSubmit = () =>
		setFormValues({ ...bankingWalletsFiltersDefaultValues });

	const getWalletData = () =>
		bankingCardsTableData?.map((transaction) => ({
			walletId: transaction?.walletId,
			customerId: transaction?.customerId,
			name: transaction?.name,
			cardIssued: transaction?.cardIssued,
			cardType: transaction?.cardType,
			issuerId: transaction?.issuerId,
			issuerName: transaction?.issuerName,
			createdAt: transaction?.createdAt,
		}));

	const handleRowClick = (_, rowValues) => {
		history.push(
			`/banking/cards/${rowValues.walletId.toLowerCase()}/card-details`
		);
	};
	return (
		<>
			<BankingWalletFilters
				formValues={formValues}
				handleChange={handleChange}
				handleSubmit={handleSubmit}
				handleSelect={handleSelect}
			/>
			<Table
				data={getWalletData()}
				headings={bankingCardsTableHeadings}
				rowClick={handleRowClick}
			/>
		</>
	);
};

export default BankingCards;
